module.exports = __webpack_public_path__ + "images/checkGreenIcon-2f8770c908648e319eb136fad2626eab.svg";